import { saveAs } from 'file-saver'
import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

// UI

import { Box, Button, Flex, HStack, Heading, Spacer } from '@chakra-ui/react'

//Hooks

//Constants
import { createExcelBlob } from '@/utils/fileHelper'

import { useInitialTableState } from '@/components/Table/components/useInitialTableState'
import FullTable from '@/components/Table/FullTable/FullTable'
import { convertTableStateToQuery } from '@/utils/tableHelper'
import { createColumnHelper } from '@tanstack/react-table'

import DateCell from '@/components/Table/components/Cell/DateCell'
import useVendor from '../useVendor'
import { FilterType } from '@/components/Table/components/Filter/TableFilter'
import { LoadingSection } from '@/components/Elements'
const TemporaryVendorListPage = () => {
  // Table State
  const [storedTableState, setStoredTableState] = useInitialTableState(`table_state:tempVendor`, {})
  const query = convertTableStateToQuery(storedTableState)

  // Hooks
  const { useFetchAllVendors } = useVendor()
  const { data: fetchVendorResponse, isLoading } = useFetchAllVendors({
    ...query,
    filters: { ...query.filters, isRegistered: 1 },
  })
  const { data: allFetchVendorResponse } = useFetchAllVendors({ page: 1, pageSize: 0, filters: { isRegistered: 1 } })

  const navigate = useNavigate()
  const columnHelper = createColumnHelper()

  const defaultColumns = useMemo(
    () => [
      columnHelper.accessor('name', {
        header: () => <span>Supplier Name</span>,
      }),

      columnHelper.accessor('tempVendorStatus', {
        meta: {
          filterVariant: FilterType.MULTI_SELECT,
          filterOptions: [
            { label: 'Open', value: 'open' },
            { label: 'Converted', value: 'converted' },
          ],
        },
      }),
      columnHelper.accessor('requestor'),
      columnHelper.accessor('createdAt', {
        header: () => <span>Date of Creation</span>,
        cell: DateCell,
        meta: {
          filterVariant: FilterType.DATE,
        },
      }),
    ],
    [columnHelper]
  )

  const handleDownload = () => {
    try {
      const excelData = allFetchVendorResponse.data.map((row) => ({
        name: row.name,
        supplierNumber: row.supplierNumber,
        components: row.allComponents,
        r4b: row.r4b ? 'yes' : '',
        contactPersonName: row.contactPersonName,
        contactPersonEmail: row.contactPersonEmail,
        remarks: row.remarks,
        projectReference: row.projectReference,
        address: row.address,
        BRNumber: row.BRNumber,
        contactNumber: row.contactNumber,
        status: row.status,
      }))
      const excelBlob = createExcelBlob(excelData)
      saveAs(excelBlob, 'Temporary Vendors.xlsx')
    } catch (err) {
      console.log(err)
    }
  }
  // Handler

  const handleOnRowClick = ({ original }) => {
    if (!original?._id) return

    navigate(`/admin/vendors/${original._id}/`)
  }

  if (isLoading) {
    return <LoadingSection />
  }

  return (
    <>
      <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="auto">
        <Flex p={5} borderBottom="1px solid #d8dbe0">
          <Heading>Temporary Vendors</Heading>
          <HStack mx="5">
            <Button colorScheme="gray" onClick={handleDownload}>
              Download
            </Button>
          </HStack>
          <Spacer />
        </Flex>
        <Box p={5} overflow="scroll">
          <FullTable
            data={fetchVendorResponse?.data ? fetchVendorResponse.data : []}
            rowCount={fetchVendorResponse?.count}
            columnDef={defaultColumns}
            state={storedTableState}
            setState={setStoredTableState}
            handleRowClick={handleOnRowClick}
          />
        </Box>
      </Box>
    </>
  )
}

export default TemporaryVendorListPage
